import NamedDto from 'modules/base/dto/NamedDto';
import { convertStringToDate } from 'modules/base/utils/ConversionUtil';
import DriverType from './DriverType';

export default class DriverTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {DriverType} */
		this.type = null;
		/** @type {Date} */
		this.created = null;
		/** @type {Date} */
		this.updated = null;
		/** @type {boolean} */
		this.open = null;
		/** @type {boolean} */
		this.connected = null;
		/** @type {Date} */
		this.lastActiveTime = null;
		/** @type {number} */
		this.autoCloseTimeout = null;
		/** @type {Date} */
		this.activeUntil = null;
	}

	/**
	 * @typedef {Object} _DriverTableDtoProps
	 * @property {string} type
	 * @property {Date} created
	 * @property {Date} updated
	 * @property {boolean} open
	 * @property {boolean} connected
	 * @property {Date} lastActiveTime
	 * @property {number} autoCloseTimeout
	 * @property {Date} activeUntil
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _DriverTableDtoProps} DriverTableDtoProps
	 */
	/**
	 *
	 * @param {DriverTableDtoProps} props
	 * @returns {DriverTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.created = props.created != null ? convertStringToDate(props.created) : null;
		this.updated = props.updated != null ? convertStringToDate(props.updated) : null;
		this.open = props.open;
		this.connected = props.connected;
		this.lastActiveTime = props.lastActiveTime !== null ? convertStringToDate(props.lastActiveTime) : null;
		this.autoCloseTimeout = props.autoCloseTimeout;
		this.activeUntil = props.activeUntil !== null ? convertStringToDate(props.activeUntil) : null;
		return this;
	}
}
